import classNames from "classnames";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";

interface Section02Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const TitleSection = ({ className, job, page, section, ...props }: Section02Props) => {
  return (
    <Section className={classNames("bg-vpBlue-200", className)} section={section} {...props}>
      <SectionContainer section={section}>
        <div className="flex flex-1 flex-col items-center gap-14">
          <div className="flex flex-col items-center gap-6">
            {section?.Title && (
              <h2
                className={classNames("text-balance text-5xl font-bold", section?.TitleElement?.ClassName)}
                id={section?.TitleElement?.HtmlId}
                style={section?.TitleElement?.Style}
                {...section?.TitleElement?.Rest}
              >
                {section?.Title}
              </h2>
            )}
            {section?.Subtitle && (
              <div
                className={classNames("text-balance text-3xl", section?.SubtitleElement?.ClassName)}
                id={section?.SubtitleElement?.HtmlId}
                style={section?.SubtitleElement?.Style}
                {...section?.SubtitleElement?.Rest}
              >
                {section?.Subtitle}
              </div>
            )}
          </div>
          {section?.Button && (
            <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
              <Button
                size="large"
                startNode={
                  section?.Button?.StartNode?.data?.attributes && (
                    <div
                      className={classNames("h-5 w-5", section?.Button?.StartNodeClassName)}
                      style={{
                        mask: `url(${section?.Button?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                        WebkitMask: `url(${section?.Button?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                      }}
                    />
                  )
                }
              >
                {section?.Button?.Value}
              </Button>
            </Link>
          )}
        </div>
      </SectionContainer>
    </Section>
  );
};

export default TitleSection;
